"use strict";

var getConfiguredDecimalAmount = require('./utils').getConfiguredDecimalAmount;

/* Return unit m3*/
exports.get = function(value, previousValue, config, result) {
  var res = getConfiguredDecimalAmount(result, config);
  var decimals = res.decimals;
  //if(!config) config = {};
  //var metersConfig = config.meters || {count:4,exist:{1:true,2:true,3:true,4:true}};
  // what is biggest precision we got from decimal pointers, in most cases it's 0.1
  // Note that we rely that highest precision is first (left) item in config and meter
  var lowestprecision = config.decimals.positions[config.decimals.positions.length - 1].precision;
  var highestprecision = config.decimals.positions[0].precision;


  if (!previousValue) return {res:parseFloat(value.toFixed(decimals)), err:null, precision:res.precision}

  // fetch away part that can be used for rolling next number:
  //  eg: previousValue = 2.4567, lowestprecision = 0.1  -> numberForRolling = 2
  //  eg: previousValue = 2.4567, lowestprecision = 0.01  -> numberForRolling = 2.4
  var numberForRolling = Math.floor(previousValue / (lowestprecision * 10)) * (lowestprecision * 10)
  var previousDecimalValue = previousValue - numberForRolling;
  var delta = value - previousDecimalValue;
  if ((delta >= 0 && delta < 0.000025) || (delta < 0 && delta > -highestprecision)) { // if value has gone backwards, report same value if delta is below precision unit (1dl for typical meters)
    // When movement is below limits, handle as same value
    return {res:parseFloat(previousValue.toFixed(decimals)), err:null, precision:res.precision}
  } else if (parseFloat(value.toFixed(decimals)) >= parseFloat(previousDecimalValue.toFixed(decimals))) {
    return {res:parseFloat((numberForRolling + value).toFixed(decimals)), err:null, precision:res.precision}
  } else {
    return {res:parseFloat((numberForRolling + (lowestprecision * 10) + value).toFixed(decimals)), err:null, precision:res.precision}
  }

  return result

}





//////////////////
// WEBPACK FOOTER
// ./~/@smartvatten/flowone-algorithms/decimalpointers/calculate-value.js
// module id = 834
// module chunks = 0